"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmenuIcon = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("../../Theme/index");
const SubmenuIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: onClick }, props),
        react_1.default.createElement("rect", { width: "24", height: "24", fill: index_1.theme.palette.BW_100 }),
        react_1.default.createElement("line", { x1: "8", y1: "6", x2: "19", y2: "6", stroke: "black", strokeWidth: "2", strokeLinecap: "round" }),
        react_1.default.createElement("line", { x1: "8", y1: "12", x2: "17", y2: "12", stroke: "black", strokeWidth: "2", strokeLinecap: "round" }),
        react_1.default.createElement("line", { x1: "8", y1: "18", x2: "19", y2: "18", stroke: "black", strokeWidth: "2", strokeLinecap: "round" }),
        react_1.default.createElement("line", { x1: "4", y1: "6", x2: "4.1", y2: "6", stroke: "black", strokeWidth: "2", strokeLinecap: "round" }),
        react_1.default.createElement("line", { x1: "4", y1: "12", x2: "4.1", y2: "12", stroke: "black", strokeWidth: "2", strokeLinecap: "round" }),
        react_1.default.createElement("line", { x1: "4", y1: "18", x2: "4.1", y2: "18", stroke: "black", strokeWidth: "2", strokeLinecap: "round" })));
};
exports.SubmenuIcon = SubmenuIcon;
